import { PostWhereInput } from "../../../generated/prisma/models";
import { prisma } from "../../lib/prisma";
import { IPostQuery } from "../post/post.interface";

const getPremiumContent = async (queryParams: IPostQuery) => {
  const limit = queryParams.limit ? parseInt(queryParams.limit) : 5;
  const page = queryParams.page ? parseInt(queryParams.page) : 1;
  const skip = (page - 1) * limit;
  const sortBy = queryParams.sortBy ? queryParams.sortBy : "createdAt";
  const sortOrder = queryParams.sortOrder ? queryParams.sortOrder : "desc";
  const tags = queryParams.tags ? JSON.parse(queryParams.tags as string) : [];
  const tagsArray = Array.isArray(tags) ? tags : [tags];

  console.log(tagsArray);

  const andConditions: PostWhereInput[] = [];
  if (queryParams.searchTerm) {
    andConditions.push({
      OR: [
        {
          title: {
            contains: queryParams.searchTerm,
            mode: "insensitive",
          },
        },
        {
          content: {
            contains: queryParams.searchTerm,
            mode: "insensitive",
          },
        },
      ],
    });
  }
  if (queryParams.status) {
    andConditions.push({ status: queryParams.status });
  }
  if (queryParams.content) {
    andConditions.push({ content: queryParams.content });
  }
  if (queryParams.authorId) {
    andConditions.push({ authorId: queryParams.authorId });
  }
  if (queryParams.isFeatured) {
    andConditions.push({ isFeatured: Boolean(queryParams.isFeatured) });
  }
  if (queryParams.tags) {
    andConditions.push({
      tags: {
        hasSome: tagsArray,
      },
    });
  }
  andConditions.push({
    isPremium: true,
  });
  const posts = await prisma.post.findMany({
    where: {
      AND: andConditions,
    },
    take: limit,
    skip: skip,
    orderBy: {
      [sortBy]: sortOrder,
    },
    include: {
      author: {
        omit: {
          password: true,
        },
      },
      comments: true,
      _count: {
        select: {
          comments: true,
        },
      },
    },
  });

  const totalPostCount = await prisma.post.count({
    where: {
      AND: andConditions,
    },
  });
  return {
    data: posts,
    meta: {
      page: page,
      limit: limit,
      total: totalPostCount,
      totalPages: Math.ceil(totalPostCount / limit),
    },
  };
};

export const premiumServices = {
  getPremiumContent,
};
